module.exports = __webpack_public_path__ + "img/sushi.eb6daf62.png";